export interface Country {
  countryId: number;
  code: string;
  name: string;
  countryPhoneCode: string;
}

export interface State {
  countryId: number;
  name: string;
  stateId: number;
  stateCode: string;
  isNational?: boolean;
}

export const DEFAULT_MOBILE_COUNTRY_CODE = 'USA';
